import Avatar from '@atlaskit/avatar';
import { colors, fontFamily } from '@atlaskit/theme';
import React, { Component } from 'react';
import styled from 'styled-components';

import { getInitials } from '../utils/initials';

export type TriggerProps = {
  readonly userName: string;
  readonly isBorderVisible: boolean;
  readonly avatarSrc?: string;
};

export class Trigger extends Component<TriggerProps> {
  public static defaultProps = {
    isBorderVisible: false
  };

  public render() {
    const { userName, avatarSrc, isBorderVisible } = this.props;
    if (avatarSrc !== undefined) {
      return (
        <Avatar
          src={avatarSrc}
          name={userName}
          size="small"
          isFocus={isBorderVisible}
          isInteractive
        />
      );
    } else {
      return (
        <Avatar
          component={({ className, ...props }) => (
            <div className={className}>
              <Initials {...props}>{getInitials(userName)}</Initials>
            </div>
          )}
          name={userName}
          size="small"
          isFocus={isBorderVisible}
          isInteractive
        />
      );
    }
  }
}

const Initials = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;

  font-family: ${fontFamily};
  font-size: 10px;
  line-height: 10px;
  color: ${colors.N500};

  width: 100%;
  height: 100%;
  background-color: ${colors.N40};
  border-radius: 50%;
`;
